import React from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';

class PLCard extends React.Component {
  handleSubmit = ev => {
    ev.preventDefault();
    if (this.props.stripe) {
      this.props.stripe
        .createToken()
        .then(payload => console.log('[token]', payload));
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  };
  render() {
    return (
  
      <label>
        <CardElement style={{base: {fontSize: '18px'}}} />
      </label>
    );
  }
};

export default injectStripe(PLCard);



// WEBPACK FOOTER //
// ./src/components/Checkout/PL-card.js